import type { LumberProfileType } from "building-types/framing/lumberTypes";
import type { UnsignedNumber } from "common/types/nominalNumbersTypes";
import type { Plane } from "geom/planeTypes";

export enum RoofTrussType {
  FLY_TRUSS = "FLY_TRUSS",
  CHORD_TRUSS = "CHORD_TRUSS",
  KING_POST_TRUSS = "KING_POST_TRUSS",
  QUEEN_POST_TRUSS = "QUEEN_POST_TRUSS",
  FINK_TRUSS = "FINK_TRUSS",
  HOWE_TRUSS = "HOWE_TRUSS",
  SCISSOR_TRUSS = "SCISSOR_TRUSS",
  STICK_FRAME_TRUSS = "STICK_FRAME_TRUSS",
  HIP_TRUSS = "HIP_TRUSS",
  GAMBREL_TRUSS = "GAMBREL_TRUSS",
  JACK_TRUSS = "JACK_TRUSS",
}

export const OmitTrussTypesFromUI = [
  RoofTrussType.FLY_TRUSS,
  RoofTrussType.HIP_TRUSS,
  RoofTrussType.GAMBREL_TRUSS,
  RoofTrussType.STICK_FRAME_TRUSS,
  RoofTrussType.JACK_TRUSS,
];

export interface RoofTrussBase<T extends RoofTrussType> {
  readonly trussType: T;
}

export interface TrussMemberSpanData {
  readonly span: UnsignedNumber;
  readonly pitch: UnsignedNumber;
  readonly profile: LumberProfileType;
}

export interface RoofTrussBasicInput extends RoofTrussBase<RoofTrussType> {
  readonly leftSpan: UnsignedNumber | TrussMemberSpanData[];
  readonly leftEaveFasciaSize: UnsignedNumber;
  readonly leftOverhang: UnsignedNumber; //should be from the wall framing
  readonly leftBearingWidth: UnsignedNumber;

  readonly rightSpan: UnsignedNumber | TrussMemberSpanData[];
  readonly rightEaveFasciaSize: UnsignedNumber;
  readonly rightOverhang: UnsignedNumber; //should be from the wall framing
  readonly rightBearingWidth: UnsignedNumber;

  readonly bottomChordOffset: number;
  readonly leftTopChordPitch: UnsignedNumber;
  readonly rightTopChordPitch: UnsignedNumber;
  readonly topChordProfile: LumberProfileType;
  readonly bottomChordProfile: LumberProfileType;

  readonly webChordProfile: LumberProfileType;
  readonly ridgeRafterProfile: LumberProfileType;
  readonly trussPlane: Plane;
}

export interface StickFrameTrussBasicInput extends RoofTrussBasicInput {
  readonly webChordHorizontalSpacing: UnsignedNumber;
  readonly lookoutProfile: LumberProfileType;
  readonly additionalPlaneOffset: number; //this additional offset is needed to account for the fact that the stick frame is oriented along the width compared to the truss members which are oriented along the height
}

export interface JackTrussBasicInput extends RoofTrussBasicInput {
  readonly side: "LEFT" | "RIGHT";
  readonly bottomChordExtension?: number;
}
